import { render, staticRenderFns } from "./PlaceholdersModal.vue?vue&type=template&id=74c4dd94&"
import script from "./PlaceholdersModal.vue?vue&type=script&lang=ts&"
export * from "./PlaceholdersModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports